import React from 'react';
import { Colors, FontWeights } from 'core/CssVariables';
import { Icon } from '../../../Icon';
import { Text } from '../../../Typography';
import { TIconNames } from '../../../Icon/Icon.type';
import { TTextNumberProps } from '../EditableNumber.type';

const TextNumber: React.FC<TTextNumberProps> = ({
  setIsEditable,
  fontWeight,
  fontLevel,
  numberValueString,
  color,
}) => {
  const onHandleClick = () => {
    setIsEditable(true);
  };

  return (
    <Text
      className="pt-1 pb-1 pl-2"
      fontLevel={fontLevel || 5}
      fontWeight={fontWeight || FontWeights.Medium}
      color={color}
      onClick={onHandleClick}
      editable={{
        icon: (
          <Icon
            icon={TIconNames.EDIT}
            color={Colors.Blue}
            size={16}
            className="edit-icon ml-2"
          />
        ),
      }}
    >
      {numberValueString}
    </Text>
  );
};

export default TextNumber;
